import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import img2 from "../../../assets/img2.jpg";

import {
  FaDumbbell,
  FaRunning,
  FaHeartbeat,
  FaStar,
  FaLeaf,
} from "react-icons/fa";

// InfoBlock Component with animation
const InfoBlock = ({ title, description, buttonText }) => {
  const [isVisible, setIsVisible] = useState(false);
  const blockRef = useRef(null);

  // Intersection Observer to detect visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once the element is visible
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (blockRef.current) {
      observer.observe(blockRef.current);
    }

    return () => {
      if (blockRef.current) {
        observer.unobserve(blockRef.current);
      }
    };
  }, []);

  return (
    <motion.div
      ref={blockRef}
      className="flex flex-col items-center p-6 rounded-lg lg:max-w-[70%]"
      initial={{ opacity: 0, y: 50 }}
      animate={isVisible ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8 }}
    >
      <h2 className="text-2xl font-bold mb-4 text-white">{title}</h2>
      <div
        className="text-lg text-center mb-4 text-white"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <motion.a
        className="px-6 py-2 bg-orange-500 text-black font-semibold rounded-lg hover:bg-orange-700"
        whileHover={{ scale: 1.05 }}
        transition={{ duration: 0.3 }}
        href="/pierwsza-wizyta"
      >
        {buttonText}
      </motion.a>
    </motion.div>
  );
};

const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const heroRef = useRef(null);

  // Intersection Observer to detect HeroSection visibility
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once the element is visible
        }
      },
      { threshold: 0.1 } // Trigger when 10% of the element is visible
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  return (
    <div className="relative w-full h-full" ref={heroRef}>
      {/* Background with image */}
      <motion.div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${img2})`,
        }}
        initial={{ opacity: 0, scale: 1 }}
        animate={isVisible ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 1, ease: "easeInOut" }}
      ></motion.div>

      {/* Background dark overlay */}
      <div className="absolute inset-0 bg-black opacity-70"></div>

      {/* Content in front of background */}
      <div className="flex justify-center items-center w-full h-full relative ">
        <div className="flex  flex-col gap-10 items-center">
          <InfoBlock
            title="TRENING EMS - PIERWSZA WIZYTA"
            description={`
              <ul class="list-disc list-inside space-y-2">
                <li>Konsultacja z trenerem odnośnie stanu zdrowia, sprawności, tego co chcesz osiągnąć trenując</li>
                <li>Trening próbny EMS, abyś mógł poczuć to na własnej skórze</li>
                <li>Drenaż limfatyczny - zrelaksujesz się tutaj w naszym kąciku przy kawie/herbacie jednocześnie wykonując drenaż. W tym miejscu omawiasz z trenerem całe spotkanie</li>
                Za jedynie <strong>69 zł!</strong> (cena standardowa 249 zł)
              </ul>
            `}
            buttonText="Zapisz się"
          />
          <InfoBlock
            title="TRENING PERSONALNE SIŁOWY - PIERWSZA WIZYTA"
            description="Pamiętaj! Tutaj nie ma kombinezonów do EMS, za to są ciężary i dużo endorfin! 😃
Wizytę zaczynamy od konsultacji odnośnie przeciwwskazań, przebytych kontuzji, tego co chcesz osiągnąć, jakie masz ograniczenia. Potem przejdziemy przez testy diagnostyczne sprawdzając możliwości, sprawdzamy ograniczenia w mobilności stawów, wzorce ruchowe. Potem będzie krótki trening wdrożeniowy, abyś miał zarys tego jak to będzie później wyglądać. Na koniec omówisz z trenerem wszystkie kwestie tego co zauważył u Ciebie w testach diagnostycznych i tego jak współpraca może wyglądać dalej
i to wszystko za jedynie 69zł!  (cena standardowa 249 zł)
"
            buttonText="Zapisz się"
          />
          <InfoBlock
            title="PROGRAM HYBRYDOWY- PIERWSZA WIZYTA"
            description="Czym jest hybryda? Połączeniem tego co najlepsze z treningów EMS i personalnych siłowych. Idealne dla niezdecydowanych!
Chcesz sprawdzić EMS w suchych kombinezonach i personalny siłowy? To jest dla Ciebie! Podczas jednej wizyty poznasz i przetestujesz dwa rodzaje treningu, na koniec jak zawsze omówienie wszystkiego z trenerem i ustalenie planu dalej!
Pierwsza wizyta jedynie 89zł
"
            buttonText="Zapisz się"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
